import { makeStyles } from '@material-ui/styles'
export const roleStyle = makeStyles(() => ({
	textDialog: {
		margin: '15px 0',
	},
}))
